import useAuth from 'hooks/useAuth'
import { useRouter } from 'next/router'
import { useSnackbar } from 'notistack'
import { PATH_AUTH } from 'routes/paths'
import { get } from 'lodash'
import { sendError } from 'helpers/log'

export default function useCheckValidToken() {
  const { enqueueSnackbar } = useSnackbar()
  const { push, query } = useRouter()
  const { token } = query
  const { claimToken } = useAuth()

  async function checkValidToken() {
    try {
      if (!token) {
        enqueueSnackbar('Token kosong!', { variant: 'warning' })
        push('/')
        return
      }

      await claimToken(String(token))
      enqueueSnackbar('Berhasil masuk!')
    } catch (error) {
      sendError(error)
      enqueueSnackbar(get(error, 'message', 'Terjadi kesalahan'), {
        variant: 'error',
      })
      push(PATH_AUTH.login)
    }
  }

  return {
    checkValidToken,
  }
}
